<template>
  <div
    :class="[
      'game',
      'game-' + gameSrcLang + '-' + gameTargetLang,
      (status !== undefined || showSolution) && 'game-finished',
    ]"
    :data-src="gameSrcLang"
    :data-target="gameTargetLang"
  >
    <h2>
      {{ gameSrcLang.toUpperCase() }} to {{ gameTargetLang.toUpperCase() }}
    </h2>
    <!--
    <button @click="onTest">test</button>
    <p>test count: {{ clickCount }}</p>
    -->
    <div class="words-lists">
      <ul class="words">
        <li
          v-for="(word, index) in selectedWords"
          class="word"
          :key="'word-' + gameSrcLang + '-' + word[gameSrcLang]"
        >
          <div
            :class="'word-src word-' + gameSrcLang"
            :title="word[gameTargetLang]"
          >
            <icelandic-term
              v-if="gameSrcLang === 'is'"
              :term="word[gameSrcLang]"
            />
            <span v-else>{{ word[gameSrcLang] }}</span>
          </div>
          <drop
            tag="div"
            :class="[
              'word-target word-' + gameTargetLang,
              showSolution
                ? 'word-target-solution'
                : target[index]
                ? target[index] === word[gameTargetLang]
                  ? 'word-target-ok'
                  : 'word-target-error'
                : 'word-target-empty',
            ]"
            @drop="onDrop($event, index)"
          >
            <drag tag="div" :data="{ from: 'target', text: target[index] }">
              {{ showSolution ? word[gameTargetLang] : target[index] }}
            </drag>
          </drop>
        </li>
      </ul>
      <transition-group name="list" tag="ul" class="choices">
        <drag
          tag="li"
          class="choice"
          v-for="(word, index) in selectedWords"
          :key="'src-to-target-' + gameSrcLang + '-' + word[gameSrcLang]"
          :data="{ from: 'choice', text: choices[index] }"
          :disabled="showSolution"
        >
          <div :class="'choice-' + gameSrcLang">
            <icelandic-term
              v-if="gameTargetLang === 'is'"
              :term="choices[index]"
            />
            <span v-else>{{ choices[index] }}</span>
          </div>
        </drag>
      </transition-group>
    </div>
  </div>
</template>

<script>
import IcelandicTerm from "@/components/IcelandicTerm.vue";
import { Drag, Drop, DropMask } from "vue-easy-dnd";
import { mapGetters } from "vuex";
const helpers = require("@/services/helpers.js");
const constants = require("@/constants.js");

export default {
  name: "GameSrcToTarget",
  components: { Drag, Drop, DropMask, IcelandicTerm },
  data() {
    // console.log(
    //   `data ${this.gameSrcLang.toUpperCase()} to ${this.gameTargetLang.toUpperCase()}`
    // );
    return {
      target: [],
      choices: [],
      clickCount: 0,
      status: undefined,
      showSolution: false,
      errors: 0,
    };
  },
  computed: {
    ...mapGetters([
      "gameSrcLang",
      "gameTargetLang",
      "gameAllowedErrors",
      "selectedWords",
      "shuffledSelectedWords",
    ]),
  },
  mounted() {
    // console.log(
    //   `mounted ${this.gameSrcLang.toUpperCase()} to ${this.gameTargetLang.toUpperCase()}`
    // );
    this.initGame();
  },
  updated() {
    // console.log(
    //   `updated ${this.gameSrcLang.toUpperCase()} to ${this.gameTargetLang.toUpperCase()}`
    // );
  },
  created() {
    // console.log(
    //   `created ${this.gameSrcLang.toUpperCase()} to ${this.gameTargetLang.toUpperCase()}`
    // );
    this.$store.subscribe((mutation, state) => {
      if (["CATEGORY_SELECTED", "NEW_GAME"].includes(mutation.type)) {
        this.initGame();
      }
    });
  },
  methods: {
    onDrop(e, index) {
      if (this.showSolution) return;

      if (e.data.text) {
        if (e.data.from === "choice") {
          let pos = this.choices.indexOf(e.data.text);
          this.choices.splice(pos, 1);

          if (this.target[index]) {
            this.choices.push(this.target[index]);
          }
        }

        if (e.data.from === "target") {
          if (this.target[index]) {
            this.choices.push(this.target[index]);
          }
          let pos = this.target.indexOf(e.data.text);
          console.log("pos=" + pos);
          this.target[pos] = "";
        }

        this.target[index] = e.data.text;
        this.target = this.target.slice(0);

        let filledTargets = this.target.filter((t) => t);

        // console.log(
        //   `filled targets: ${filledTargets} // choices: ${this.choices}`
        // );

        if (
          this.choices.length + filledTargets.length >
          constants.SELECTED_WORDS_SIZE
        ) {
          console.log(
            `too many targets+choices: ${
              this.choices.length + filledTargets.length
            }`
          );
        }

        if (this.choices.length == 0) {
          let ok = true;
          for (let ii = 0; ii < this.selectedWords.length; ii++) {
            if (
              this.selectedWords[ii][this.gameTargetLang] !== this.target[ii]
            ) {
              ok = false;
              break;
            }
          }
          this.setGameStatus(ok);
        } else {
          if (
            this.target[index] ===
            this.selectedWords[index][this.gameTargetLang]
          ) {
            this.setGameStatus(undefined);
          } else {
            this.setGameStatus(false);
          }
        }
      }
    },
    onTest() {
      this.clickCount++;
      this.target[0] = "" + this.clickCount;
    },
    initGame() {
      console.log(
        `GameSrcToTarget initGame ${this.gameSrcLang.toUpperCase()} to ${this.gameTargetLang.toUpperCase()}`
      );

      this.showSolution = false;
      this.target = [];
      this.choices = [];
      for (let ii = 0; ii < this.shuffledSelectedWords.length; ii++) {
        this.target.push("");
        this.choices.push(this.shuffledSelectedWords[ii][this.gameTargetLang]);
      }
      this.setGameStatus(undefined);
      this.errors = 0;
    },
    setGameStatus(status) {
      if (status === false) {
        this.errors++;
        if (this.errors < this.gameAllowedErrors) return;
      }
      this.status = status;
      this.$emit("gameStatus", this.status);
    },
    solution() {
      this.showSolution = true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/scss/components-shared.scss";

.words-lists {
  display: inline-flex;
  align-items: center;
}
.words,
.choices {
  list-style: none;
}
.words {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.words .word {
  display: flex;
  height: 32px;
  align-items: center;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.word-target {
  margin-left: 1rem;
  background-color: #aaa;
  height: 32px;
  min-width: 32px;
  border-radius: 16px;
}
.word-target-ok {
  background-color: green;
  color: white;
}
.word-target-error {
  background-color: red;
  color: white;
}
.word-target-solution {
  background-color: orange;
  color: white;
}
.word-target-ok,
.word-target-error,
.word-target-solution {
  display: flex;
  align-items: center;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.choices {
  margin-left: 3rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.choices .choice {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  text-align: left;
  font-style: italic;
}

.drop-allowed {
  background-color: rgba(33, 113, 181, 0.5);
}

.drop-forbidden {
  background-color: rgba(255, 0, 0, 0.2);
}

.drop-in {
  background-color: rgba(165, 205, 255, 0.8);
  box-shadow: 0 0 10px rgba(0, 0, 255, 0.8);
}
</style>
